// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { useEventListener } from "@vueuse/core";

import { whenSelectsReady } from "#/admin/legacy/sp-select/when-selects-ready.js";
import { blankSelectItem } from "#/admin/legacy/sp-select/index.js";

const listeners = new WeakMap();
const SECONDARY_CATEGORY_SELECTOR = '[data-attribute="secondary-categories"]';

/**
 * Initializes primary-category synchronization within `root`.
 * Returns its disposer, or undefined when no primary category is in an owning form.
 */
export function initializeCategorySelection(root = document) {
  const mainControl = root.querySelector('[id="main_category_select"]');
  const form = mainControl?.closest("form");

  if (!mainControl || !form) {
    return;
  }

  const existing = listeners.get(form);

  if (existing) {
    return existing;
  }

  function handleCategoryChange(event) {
    if (event.target.matches(SECONDARY_CATEGORY_SELECTOR)) {
      whenSelectsReady([mainControl, event.target], updateMainCategoryOptions);
    }
  }

  function updateMainCategoryOptions() {
    const selected = mainControl.value;
    const blank = mainControl.items.find((item) => item.value === "") || blankSelectItem();
    const items = new Map([["", blank]]);

    for (const item of mainControl.items) {
      if (String(item.value) === String(selected)) {
        items.set(String(item.value), item);
      }
    }

    for (const control of form.querySelectorAll(SECONDARY_CATEGORY_SELECTOR)) {
      const values = new Set([].concat(control.value || []).map(String));

      for (const item of control.items) {
        if (values.has(String(item.value)) && String(item.value) !== String(selected)) {
          items.set(String(item.value), item);
        }
      }
    }

    mainControl.items = [...items.values()].sort((a, b) => a.title.localeCompare(b.title));
  }

  const stop = useEventListener(form, "change", handleCategoryChange);

  function disposeCategorySelection() {
    stop();

    if (listeners.get(form) === disposeCategorySelection) {
      listeners.delete(form);
    }
  }

  listeners.set(form, disposeCategorySelection);

  return disposeCategorySelection;
}
